import { Action, applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { ActionsObservable, combineEpics, createEpicMiddleware, StateObservable } from 'redux-observable';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { ApplicationState, reducers } from './';
import { refreshConfigEpic, sendConfigEpic } from './TransportApp';
import { catchError } from 'rxjs/operators';
import { refreshTwinEpic } from './Modems';
import { actionCreators, SnackbarAction } from './AlertSnackbarStore';
import { concat, of } from 'rxjs';

/** contains configuration of the Redux store. This includes middleware and setting up epics
 * See https://redux-toolkit.js.org/api/configureStore
 */
export default function configureStore(history: History, initialState?: ApplicationState) {
    const epicMiddleware = createEpicMiddleware<Action<any>, Action<any>, ApplicationState>()
    const middleware = [
        thunk,
        routerMiddleware(history),
        epicMiddleware
    ];

    const rootReducer = combineReducers({
        ...reducers,
        router: connectRouter(history)
    });

    const enhancers = [];
    const windowIfDefined = typeof window === 'undefined' ? null : window as any;
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }
    const store = createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    )
    const rootEpic = (action$: ActionsObservable<any>, store$: StateObservable<ApplicationState>) =>
        combineEpics(refreshConfigEpic, sendConfigEpic, refreshTwinEpic)(action$, store$).pipe(
            // catch any errors, also restart the epics. If they error out at any time without this, all epics will stop
            catchError((error, source) => {
                console.error(error)
                return concat(of(actionCreators.addError(error)), source)
            })
        );
    epicMiddleware.run(rootEpic)
    return store
}
